
import Chip from '@mui/material/Chip';
import React, { Component } from 'react';
import LOOKUP from 'constants/lookup';
import DialogInput from 'screens/components/advanced/DialogInput';
import Button from 'screens/components/basic/Button';
import CheckInput from 'screens/components/basic/CheckInput';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';

class ScheduleSendDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            employeesSelected: [],
            searchText: ""
        };

        this.onSelect = this.onSelect.bind(this);
        this.updateInput = this.updateInput.bind(this);
    }

    componentWillReceiveProps(newProps) {
        if (newProps.open != undefined && newProps.open == false) {
            this.setState({ ...this.state, employeesSelected: [], searchText: "" })
        }
    }

    onSelect = (event, selectedOps, reason) => {
        const allSelected = this.props.employeeOptions.length === this.state.employeesSelected.length;

        if (reason === "selectOption" || reason === "removeOption") {
          if (selectedOps.find((option) => option.value === "0")) {
            console.log(allSelected);
            if (!allSelected) {
              this.setState({ ...this.state, employeesSelected: this.props.employeeOptions, searchText: "" })
            } else {
                this.setState({ ...this.state, employeesSelected: [], searchText: "" })
            }
    
          } else {
            this.setState({ ...this.state, employeesSelected: selectedOps, searchText: "" })
          }
        } else if (reason === "clear") {
            this.setState({ ...this.state, employeesSelected: [], searchText: "" })
        }
    };

    updateInput = (e) => {
        if (e){
            const inputValue = e.target.value;
            this.setState({ ...this.state, searchText: inputValue })
        }
    }

    removeEmployee = (e) => {
        let newList = this.state.employeesSelected.filter(x => x != e);
        this.setState({ ...this.state, employeesSelected: newList })
    }

    sendSchedule = () => {
        this.props.sendSchedule(this.state.employeesSelected.map((item) => { return item.value }))
    }

    onCheck = () => {
        this.setState({ ...this.state, employeesSelected: [] })
    }

    render() {
        const p = this.props;
        const e = this.state && this.state.error;
        const actions = [
            <Button
                key="ConfirmButton"
                name="buttonJustThis"
                className="pull-right btn-space"
                label="Send Schedule"
                primary={true}
                onTouchTap={this.sendSchedule}
            />,
            <Button
                key="SaveButton"
                name="buttonSave"
                className="pull-right mr-2"
                label="Cancel"
                onTouchTap={this.props.close}
            />

        ];

        const employees = [...p.employeeOptions]

        const styles = {
            chip: {
                margin: 4
            },
            wrapper: {
                display: 'flex',
                flexWrap: 'wrap'
            }
        };

        const filter = createFilterOptions();
        const allSelected = employees.length === this.state.employeesSelected.length;

        return (
            <DialogInput
                title={<DialogHeaderWithClose text="Send Schedule" handleClose={this.props.close} />}
                modal={true}
                actions={actions}
                className="schedule_dialog_send"
                open={p.open}
                autoScrollBodyContent={true}
            >
                <div className="row m-2" >
                    <div >
                        Select the employees you want to send the schedule:
                        <div className="d-flex align-items-center">
                            Send schedule by: &nbsp;
                            <CheckInput
                                name={"ScheduleSendByEmail"}
                                text={"Email"}
                                value={true}
                                onCheck={this.onCheck}
                            />
                            <CheckInput
                                name={"ScheduleSendBySMS"}
                                text={"SMS"}
                                value={false}
                                onCheck={this.onCheck}
                            />
                        </div>
                    </div>
                    <Autocomplete
                        multiple
                        options={(employees || [])}
                        className="EmployeeMultiSelect hideChips"
                        label="Select employee"
                        value={this.state.employeesSelected}
                        inputValue={this.state.searchText}
                        getOptionLabel={(item) => `${item.text} - ${item.value}`}
                        filter={Autocomplete.caseInsensitiveFilter}
                        filterOptions={(options, params) => {
                        const filtered = filter(options, params);
                            return [{ text: "All employees", value: "0" }, ...filtered];
                        }}
                        renderOption={(props, option, { selected }) => {
                        const selectAllProps =
                            option.value === "0" ? { checked: allSelected } : {};
                        return (
                            <li key={option.value} {...props}>
                                {option.text}
                            </li>
                        );
                        }}
                        renderInput={(params) => (
                        <TextField {...params} label="Select employee" variant="standard"
                            placeholder={this.state.employeesSelected.length > 5 ? `${this.state.employeesSelected.length} selected` : ``} InputLabelProps={{ shrink: true }} />
                        )}
                        openOnFocus={false}
                        onChange={this.onSelect}
                        onInputChange={this.updateInput}
                        errorText={e && (productName === undefined || productName === null || productName == 0) ? p.error : ''}
                        listStyle={{ maxHeight: 200, overflow: 'auto', width: 'auto' }}
                    />
                    <div className='container' style={{ width: '100%' }}>
                        <div className="row m-0">
                            {
                                this.state.employeesSelected.length == 0 ? (
                                    <div className="col-lg-4"><h5>No employees selected</h5></div>
                                ) : (
                                    this.state.employeesSelected.map((item, key) => (
                                        <div className="col-lg-4" key={key}>
                                            <Chip
                                                className="employeeChip"
                                                label={item.text.length > 14 ? item.text.substring(0, 14) + "..." : item.text}
                                                onDelete={() => { this.removeEmployee(item) }}
                                                sx={{ backgroundColor: '#551073', ...styles.chip }}
                                            />
                                        </div>
                                    ))
                                )
                            }
                        </div>
                    </div>

                </div>
            </DialogInput>
        );
    }
}


export default ScheduleSendDialog;